export const BASE_COMBUSTION_COLUMN_HEADINGS = [  { title: "Date", fieldName: "createdAt" },
  { title: "Consumption Month", fieldName: "consumptionPeriod" },
  { fieldName: "industrialEquipment", title: "Equipment" },
  { fieldName: "typeOfEntry", title: "Type of Entry" },
  { fieldName: "quantityConsumed", title: "Quantity Consumed" },
];

export const COMBUSTION_ADMIN_COLUMN_WIDTH = "12% 14% 17% 16% 15% 18% 8%";

export const buildCombustionColumnHeadings = (showFacilityColumn) =>
  showFacilityColumn
    ? [
        BASE_COMBUSTION_COLUMN_HEADINGS[0],
        { title: "Facility Name", fieldName: "facilityName" },
        ...BASE_COMBUSTION_COLUMN_HEADINGS.slice(1),
      ]
    : BASE_COMBUSTION_COLUMN_HEADINGS;

export const getCombustionColumnWidth = (showFacilityColumn, normalColumnWidth) =>
  showFacilityColumn ? COMBUSTION_ADMIN_COLUMN_WIDTH : normalColumnWidth;

export const combustionGridSx = (columnWidth, stretch = false) => ({
  display: "grid",
  gridTemplateColumns: columnWidth,
  alignItems: stretch ? "stretch" : "center",
  "& > .MuiTypography-root": {
    padding: "4px 10px",
    minHeight: 36,
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    lineHeight: 1.25,
    boxSizing: "border-box",
  },
  "& > .MuiBox-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 36,
    padding: "2px 4px",
    boxSizing: "border-box",
  },
});
